import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PatientMappingFormContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gridGap: '1em',
  minWidth: '600px',
}));
